import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import Home from './LandingPages/Home';
import Register from './LandingPages/Register/Register';
import Login from './LandingPages/Login';
import AppHome from './App/AppHome';
import { AuthProvider } from './Contexts/AuthContext';
import ReligiousPlaceForm from './App/ReligiousPlaceForm';
import RecoverPassword from './LandingPages/RecoverPassword';
import ChangePassword from './LandingPages/ChangePassword';
import PlaceList from './App/PlaceList';
import PlacePictures from './App/PlacePictures';
import EventsHome from './App/EventsHome';
import EventsForm from './App/EventsForm';
import UserHome from './App/UserHome';
import UserHomeEventsComponent from './Components/UserHomeEventsComponent';
import UserHomeMyPlacesComponent from './Components/UserHomeMyPlaceComponent';
import UserHomePlacesComponent from './Components/UserHomePlacesComponent';
import InstallPromptComponent from './Components/InstallPromptComponent';
import DonationSuccess from './App/DonationSuccess';
import DonationCancel from './App/DonationCancel';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route exact path='/' element={<Home />} />
          <Route exact path='/login' element={<Login />} />
          <Route exact path='/register' element={<Register />} />
          <Route exact path='/app/register_place' element={<ReligiousPlaceForm />} />
          <Route exact path='/app/home' element={<AppHome />} />
          <Route exact path='/recover_password' element={<RecoverPassword />} />
          <Route exact path='/recover_password/:code' element={<ChangePassword />} />

          <Route exact path='/app/place_list' element={<PlaceList />} />
          <Route exact path='/app/place_pictures' element={<PlacePictures />} />

          <Route exact path='/app/events_home' element={<EventsHome />} />
          <Route exact path='/app/events_form' element={<EventsForm />} />
          <Route exact path='/app/events_form/:access_key' element={<EventsForm />} />

          <Route exact path='/app/user_home' element={<AppHome />} />
          <Route exact path='/app/user_home_events' element={<UserHomeEventsComponent />} />
          <Route exact path='/app/user_home_places' element={<UserHomePlacesComponent />} />
          <Route exact path='/app/user_home_my_place' element={<UserHomeMyPlacesComponent />} />
          <Route exact path='/app/donate/success' element={<DonationSuccess />} />
          <Route exact path='/app/donate/cancel' element={<DonationCancel />} />

        </Routes>
        <InstallPromptComponent />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
